import styles from './styles.module.scss'
import PreviewModal, { DefaultWaterMarkOption } from '../previewModal'
import { useSetupHook } from './hooks'
export interface Props {
  src?: string
}
export default function ThumbnailPreview(props: Props) {
  const { src } = props

  const { state, cancelPreviewModal, showPreviewModal } = useSetupHook(props)
  const { previewModalOption } = state

  return (
    <div className={styles['container']}>
      <img
        className={styles['img-item']}
        src={src}
        alt=""
        onClick={showPreviewModal}
      />
      <PreviewModal
        {...previewModalOption}
        onCancel={cancelPreviewModal}
        waterMarkOption={DefaultWaterMarkOption}
      />
    </div>
  )
}
import styles from './styles.module.scss'
import PreviewModal, { DefaultWaterMarkOption } from '../previewModal'
import { useSetupHook } from './hooks'
export interface Props {
  src?: string
}
export default function ThumbnailPreview(props: Props) {
  const { src } = props

  const { state, cancelPreviewModal, showPreviewModal } = useSetupHook(props)
  const { previewModalOption } = state

  return (
    <div className={styles['container']}>
      <img
        className={styles['img-item']}
        src={src}
        alt=""
        onClick={showPreviewModal}
      />
      <PreviewModal
        {...previewModalOption}
        onCancel={cancelPreviewModal}
        waterMarkOption={DefaultWaterMarkOption}
      />
    </div>
  )
}
